export const analyticsId = {
  CANCEL_MIGRATION_LINK: 'CANCEL_MIGRATION_LINK',
  EXIT_HEADER_BUTTON: 'EXIT_HEADER_BUTTON',
  INFO_VIEW: 'INFO_VIEW',
  MIGRATE_BUTTON: 'MIGRATE_BUTTON',
};

export const catalogue = {
  [analyticsId.INFO_VIEW]: () => ({
    event_name: 'step_information',
    pageName: '/migration/step0/information',
    sectionFamily: 'banking',
    sectionCategory: 'services',
    sectionName: 'customer',
    interactionType: 'funnel',
    serviceType: 'userSettings',
    processType: 'migration',
    processStep: 'step0',
    processDetail: 'information',
    nombrePagina: 'proc-migracion/paso_0/informacion',
    tipoProceso: 'proc-migracion',
    pasoProceso: 'paso_0',
    detalleProceso: 'informacion',
    tipoPagina: 'generica',
  }),
  [analyticsId.CANCEL_MIGRATION_LINK]: () => ({
    categoriaEvento: 'interaccion en migracion',
    accionEvento: 'paso_0',
    etiquetaEvento: 'no quiero migrar al nuevo banco',
    action: 'click',
    format: 'link',
    component: 'lowerNavigation',
    element: 'IDoNotWantToMigrateToTheNewBank',
  }),
  [analyticsId.MIGRATE_BUTTON]: () => ({
    categoriaEvento: 'interaccion en migracion',
    accionEvento: 'paso_0',
    etiquetaEvento: 'quiero migrar al nuevo banco',
    action: 'click',
    format: 'button',
    component: 'lowerNavigation',
    element: 'IWantToMigrateToTheNewBank',
  }),
  [analyticsId.EXIT_HEADER_BUTTON]: () => ({
    categoriaEvento: 'interaccion en migracion',
    accionEvento: 'paso_0',
    etiquetaEvento: 'salir',
    action: 'exit',
    format: 'button',
    component: 'header',
    element: 'exit',
  }),
};
